import css from "csstype";

const rowConsistent: css.Properties = {
  backgroundColor: "#d4edda",
};

const rowInconsistent: css.Properties = {
  backgroundColor: "#f8d7da",
};

const statusLabelAccepted: css.Properties = {
  color: "#0a7c00",
};

const statusLabelRejected: css.Properties = {
  color: "#a4262c",
};

const statusLabelInline: css.Properties = {
  fontSize: "13px",
  marginRight: "10px",
};

const actionsCell: css.Properties = {
  minWidth: "150px",
};

const actionsCellLayout: css.Properties = {
  gap: "6px",
  display: "flex",
  alignItems: "center",
};

const dialogContentWrapper: css.Properties = {
  marginTop: "12px",
};

const textarea: css.Properties = {
  width: "300px",
};

const validationError: css.Properties = {
  color: "#a4262c",
  marginTop: "8px",
};

const styles = {
  rowConsistent,
  rowInconsistent,
  statusLabelAccepted,
  statusLabelRejected,
  statusLabelInline,
  actionsCell,
  actionsCellLayout,
  dialogContentWrapper,
  textarea,
  validationError,
};

export default styles;
